/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nuget-versions-modal-title-container{display:flex;align-items:center;height:40px}.nuget-versions-modal-title-container .version-title{margin-left:10px}.nuget-versions-modal-title-container .back-button{margin-right:10px}.nuget-versions-modal-container .mat-tab-label{flex-grow:1}"];
export { styles as styles };
